export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/NE-44b5d24271c0e060ce942faec84f1f76.png";